import { TypographyDetail } from '@seen/ui'
import type { ReactNode } from 'react'
import { Skeleton } from '#src/components/core/Skeleton.tsx'

export interface InboxRowSubtextProps {
  children: ReactNode
  isLoading?: boolean
}

export function InboxRowSubtext({
  children,
  isLoading = false,
}: InboxRowSubtextProps): ReactNode {
  if (isLoading) {
    return (
      <div className="h-4 w-48 py-0.5">
        <Skeleton className="size-full" />
      </div>
    )
  }
  return (
    <TypographyDetail className="line-clamp-1 leading-4 text-foreground-secondary">
      {children}
    </TypographyDetail>
  )
}
